import lrUploadModel from './_src/lrUploadModel.vue'

lrUploadModel.install = function(Vue) {
  Vue.component(lrUploadModel.name, lrUploadModel)
}

export default lrUploadModel